import { Directive } from '@angular/core';
import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';

@Directive({
  selector: '[appNameValidation]'
})
export class NameValidationDirective {

  constructor() { }

}

export function nameValidation(form: FormGroup): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control && control.value && form) {
      let firstNameVal = form.controls['firstName'].value.toLowerCase();
      // let middleNameVal = form.controls['middleName'].value.toLowerCase();
      if (firstNameVal) {
        if (firstNameVal === control.value.toLowerCase()) {
          return { 'nameValidation': { value: control.value } }
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
}
export function midNameValidation(form: FormGroup): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control && control.value && form) {
      // let lastNameVal = form.controls['lastName'].value.toLowerCase();
      let firstNameVal = form.controls['firstName'].value.toLowerCase();
      if (firstNameVal) {
        if (firstNameVal === control.value.toLowerCase()) {
          return { 'midNameValidation': { value: control.value } }
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
}